export const theme = {
    primaryColor: "#523499",
    cancelColor: "#d64d4d",
    neutralColor: "#545454",
    greenColor: "#509C76",
    blueColor: "#0097B9"
}